import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {RequestInterceptorService} from 'app/core/services';
// import {Store} from "@ngxs/store";
import {NgxsModule} from "@ngxs/store";
// import {NgxsReduxDevtoolsPluginModule} from "@ngxs/devtools-plugin";
import {environment} from "../../environments/environment";
import {TabsState} from "../store/states/tabs.state";
import {JatakTabStates} from "../store/states/jatak-tab.states";
import {FormStates} from "../store/states/form.state";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    NgxsModule.forRoot([TabsState,JatakTabStates,FormStates],{
      developmentMode : !environment.production
    })
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: RequestInterceptorService,
    multi: true
  }]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
